import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';

import BuildOnHat from './sections/BuildOnHat';
import DataswiftSolutions from './sections/DataswiftSolutions';
import AboutHat from './sections/AboutHat';
import BuildForHat from './sections/BuildForHat';
import { useAuthRedirect, useDataswiftNotification } from '../../helpers/customHooks';
import { useThemeContext } from '../../styles/Provider';
import NavHeader from '../../components/NavHeader/NavHeader';

type LandingPageProps = {
  path?: string;
  default?: boolean;
};

const LandingPage: React.FC<LandingPageProps> = () => {
  const [navDrawerOpen, setNavDrawerOpen] = useState(false);
  const ribbon = useDataswiftNotification(true);
  const loggedIn = useAuthRedirect();
  const { setTheme } = useThemeContext();

  useEffect(() => {
    const prefersLight = window.matchMedia?.('(prefers-color-scheme: light)').matches;
    if (prefersLight) setTheme('light');
  }, [setTheme]);

  if (loggedIn) return null;

  const onPageClick = () => {
    if (navDrawerOpen) setNavDrawerOpen(false);
  };

  return (
    <Grid container className="ds-landing-page">
      <Grid item>
        <NavHeader
          drawerOpen={navDrawerOpen}
          handleDrawerToggle={() => setNavDrawerOpen(!navDrawerOpen)}
        />
      </Grid>

      {ribbon}

      <Grid item xs>
        <div className={`${navDrawerOpen ? ' blurred' : ''}`} onClick={onPageClick}>
          <BuildOnHat />
          <DataswiftSolutions />
          <AboutHat />
          <BuildForHat />
        </div>
      </Grid>
    </Grid>
  );
};

export default LandingPage;
